import type { ReactElement } from "react";

export const navDrawerEntryType = {
  link: "link",
  group: "group"
} as const;

export type NavDrawerEntryType =
  (typeof navDrawerEntryType)[keyof typeof navDrawerEntryType];

export type NavLinkBody = {
  text: string;
  to: string;
  icon: () => ReactElement;
  altIcon: (color: string) => ReactElement;
  additionalRoutes?: string[];
};

export type NavLink = {
  entryType: typeof navDrawerEntryType.link;
} & NavLinkBody;

export type NavGroupChild = {
  text: string;
  to: string;
  match: (pathname: string, search: string) => boolean;
  icon: () => ReactElement;
  altIcon: (color: string) => ReactElement;
};

export type NavGroup = {
  entryType: typeof navDrawerEntryType.group;
  id: string;
  text: string;
  icon: () => ReactElement;
  altIcon: (color: string) => ReactElement;
  children: NavGroupChild[];
};

export type NavDrawerEntry = NavLink | NavGroup;
